<ng-container *ngIf="isNonPoweredAsset; else pingResetVehicle">
  <ng-container *ngTemplateOutlet="couldNotBeRestartFromReveal"></ng-container>
  <span class="troubleshoot-section__head" i18n="@@S_FIND_A_SOLUTION">Find a solution in the Help Center</span>
  <a
    href="{{ assetTroubleshootingUrl }}"
    class="troubleshoot-section__assets-link link-with-icon"
    target="_blank"
    a7s-id="device-health-check-hc-assets-link"
  >
    <span i18n="@@S_LINK_TO_ASSET_TROUBLESHOOT_ARTICLE" class="link-with-icon__text"
      >What to do when an asset tracker is not reporting?</span
    >
    <mat-icon svgIcon="ic-link" class="mat-icon-size-xs link-with-icon__icon"></mat-icon>
  </a>
</ng-container>

<ng-template #pingResetVehicle>
  <span
    class="troubleshoot-section__head"
    [class.troubleshoot-section__head--calamp]="!isPingSupported"
    i18n="@@S_LIVE_MAP_DHC_RESTART_VEHICLE_TRACKER"
    >Restart vehicle tracker</span
  >
  <span class="troubleshoot-section__body-head" i18n="@@S_FOLLOW_THESE_STEPS">Follow these steps to get your tracker reporting again.</span>

  <ng-container *ngIf="isPingSupported; else calamp">
    <mat-stepper class="troubleshoot-section__stepper" orientation="vertical" (selectionChange)="resetStepperToStart($event)" #stepper>
      <mat-step>
        <ng-template matStepLabel i18n="@@S_CHECK_VEHICLE">Check vehicle</ng-template>
        <ng-template matStepContent>
          <div class="troubleshoot-section__stepper__check-vehicle">
            <div class="troubleshoot-section__stepper__check-vehicle__instructions">
              <span i18n="@@S_LIVE_MAP_DHC_CHECK_VEHICLE_STEPS_1">Make sure the vehicle is:</span>
              <ul class="troubleshoot-section__stepper__check-vehicle__instructions__list">
                <li i18n="@@S_LIVE_MAP_DHC_CHECK_VEHICLE_STEPS_2">Switched on but not moving (idling)</li>
                <li i18n="@@S_LIVE_MAP_DHC_CHECK_VEHICLE_STEPS_3">In cellular range with a clear view of the sky</li>
              </ul>
            </div>
            <div class="troubleshoot-section__stepper__check-vehicle__info-area">
              <mat-icon class="mat-icon-size-xs" svgIcon="ic-info-blue"></mat-icon>
              <span i18n="@@S_LIVE_MAP_DHC_CHECK_VEHICLE_STEPS_4"
                >If the vehicle has not been driven in the last 24 hours, take it for a short drive</span
              >
            </div>
            <button
              mat-flat-button
              color="accent"
              class="troubleshoot-section__stepper__check-vehicle__next-button btn-uppercase"
              i18n="@@S_NEXT"
              a7s-id="device-health-check-step1-continue"
              matStepperNext
            >
              NEXT
            </button>
          </div>
        </ng-template>
      </mat-step>
      <mat-step
        [hasError]="restartStepState === 'PingFailed' || restartStepState === 'ResetFailed'"
        [completed]="restartStepState === 'ResetSuccess'"
      >
        <ng-template matStepLabel i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_TITLE" *ngIf="restartStepState === 'NotSent'"
          >Restart tracker</ng-template
        >
        <ng-template
          matStepLabel
          i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_RESTARTING_1"
          *ngIf="restartStepState === 'PingPending' || restartStepState === 'ResetPending'"
          >Restarting tracker.</ng-template
        >
        <ng-template
          matStepLabel
          i18n="@@S_LIVE_MAP_DHC_RESTART_FAILED_TITLE"
          *ngIf="restartStepState === 'PingFailed' || restartStepState === 'ResetFailed'"
          >Restart failed</ng-template
        >
        <ng-template matStepLabel i18n="@@S_LIVE_MAP_DHC_RESTART_COMPLETE_TITLE" *ngIf="restartStepState === 'ResetSuccess'"
          >Restart complete</ng-template
        >
        <ng-template matStepContent>
          <ng-container *ngTemplateOutlet="restartStepNotSent"></ng-container>
          <ng-container *ngTemplateOutlet="restartStepPingPending"></ng-container>
          <ng-container *ngTemplateOutlet="restartStepPingFailed"></ng-container>
          <ng-container *ngTemplateOutlet="restartStepResetPending"></ng-container>
          <ng-container *ngTemplateOutlet="restartStepResetSuccess"></ng-container>
          <ng-container *ngTemplateOutlet="restartStepResetFailed"></ng-container>
        </ng-template>
      </mat-step>
      <!-- Set inline=true to scale the icon and align it horizontally -->
      <ng-template matStepperIcon="done">
        <mat-icon inline="true">done</mat-icon>
      </ng-template>
      <!-- Override to keep icons as numbers during edit -->
      <ng-template matStepperIcon="edit" let-index="index">
        <ng-container>{{ index + 1 }}</ng-container>
      </ng-template>
      <ng-template matStepperIcon="error">
        <mat-icon svgIcon="ic-exclamation" class="mat-icon-size-xs troubleshoot-section__stepper__error-icon"></mat-icon>
      </ng-template>
    </mat-stepper>
  </ng-container>
</ng-template>

<ng-template #calamp>
  <div class="troubleshoot-section__calamp">
    <ul class="troubleshoot-section__calamp-list">
      <li i18n="@@S_TURN_ON_VEHICLE">Turn on the vehicle.</li>
      <li i18n="@@S_TAKE_FOR_DRIVE">Take it for a short drive (if it has not been driven in the past 24hours).</li>
      <li i18n="@@S_MAKE_SURE_IN_CELLULAR_RANGE">Make sure it is in cellular range with a clear view of the sky.</li>
      <li i18n="@@S_NOT_REPORTING_FOLLOW_STEPS">If the vehicle is still not reporting, follow the steps in our troubleshooting guide.</li>
      <a
        href="{{ vehicleTroubleshootingUrl }}"
        class="troubleshoot-section__calamp-vehicles-link link-with-icon"
        target="_blank"
        a7s-id="device-health-check-step2-hc-link"
      >
        <span i18n="@@S_LINK_TO_VEHICLE_TROUBLESHOOT_ARTICLE" class="link-with-icon__text">Why is my vehicle not reporting?</span>
        <mat-icon svgIcon="ic-link" class="mat-icon-size-xs link-with-icon__icon"></mat-icon>
      </a>
    </ul>
    <ng-container *ngTemplateOutlet="couldNotBeRestartFromReveal"></ng-container>
  </div>
</ng-template>

<ng-template #restartStepNotSent>
  <div
    *ngIf="restartStepState === 'NotSent'"
    class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__not-sent"
  >
    <span class="troubleshoot-section__stepper__restart__not-sent__text" i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_SUBTITLE"
      >Restart the vehicle tracker so that it starts sending data to Reveal again.</span
    >
    <button
      class="troubleshoot-section__stepper__restart__not-sent__back-button btn-uppercase"
      mat-button
      a7s-id="device-health-check-restart-back-button"
      i18n="@@S_BACK"
      (click)="resetStepperToStart()"
    >
      BACK
    </button>
    <button
      class="troubleshoot-section__stepper__restart__not-sent__restart-button btn-uppercase"
      mat-flat-button
      color="accent"
      a7s-id="device-health-check-restart-start-button"
      i18n="@@S_LIVE_MAP_DHC_RESTART_BUTTON"
      (click)="onRestartClicked()"
    >
      RESTART
    </button>
  </div>
</ng-template>

<ng-template #restartStepPingPending>
  <div
    *ngIf="restartStepState === 'PingPending'"
    class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__ping-pending"
  >
    <mat-spinner
      class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__ping-pending__spinner"
      diameter="24"
    ></mat-spinner>
    <span class="troubleshoot-section__stepper__restart__ping-pending__text" i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_PINGING_1"
      >Checking the vehicle is online.</span
    >
    <span class="troubleshoot-section__stepper__restart__ping-pending__text" i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_PINGING_2"
      >This may take a couple of minutes.</span
    >
  </div>
</ng-template>

<ng-template #restartStepPingFailed>
  <div
    *ngIf="restartStepState === 'PingFailed'"
    class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__ping-failed"
  >
    <span class="troubleshoot-section__stepper__restart__ping-failed__text" i18n="@@S_LIVE_MAP_DHC_RESTART_FAILED_OFFLINE_DESCRIPTION"
      >Tracker is offline. We could not restart the tracker. Read our troubleshooting guide and try again.</span
    >
    <a class="troubleshoot-section__stepper__restart__ping-failed__link" [href]="vehicleTroubleshootingUrl" target="_blank">
      <span i18n="@@S_LIVE_MAP_DHC_RESTART_TROUBLESHOOTING_GUIDE_LINK">Troubleshooting guide</span>
      <mat-icon class="mat-icon-size-xs" svgIcon="ic-link"></mat-icon>
    </a>
    <button
      class="troubleshoot-section__stepper__restart__ping-failed__back-button btn-uppercase"
      mat-button
      a7s-id="device-health-check-restart-ping-failed-back-button"
      i18n="@@S_BACK"
      (click)="resetStepperToStart()"
    >
      BACK
    </button>
    <button
      class="troubleshoot-section__stepper__restart__ping-failed__retry-button btn-uppercase"
      mat-flat-button
      color="accent"
      a7s-id="device-health-check-restart-ping-failed-retry-button"
      i18n="@@S_LIVE_MAP_DHC_RESTART_RETRY_BUTTON"
      (click)="onRestartClicked()"
    >
      RETRY
    </button>
  </div>
</ng-template>

<ng-template #restartStepResetPending>
  <div
    *ngIf="restartStepState === 'ResetPending'"
    class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__reset-pending"
  >
    <mat-spinner
      class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__reset-pending__spinner"
      diameter="24"
    ></mat-spinner>
    <span class="troubleshoot-section__stepper__restart__reset-pending__text" i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_RESTARTING_1"
      >Restarting tracker.</span
    >
    <span class="troubleshoot-section__stepper__restart__reset-pending__text" i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_PINGING_2"
      >This may take a couple of minutes.</span
    >
  </div>
</ng-template>

<ng-template #restartStepResetSuccess>
  <div
    *ngIf="restartStepState === 'ResetSuccess'"
    class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__reset-success"
  >
    <ng-container *ngIf="restartSuccessConfirmed === null || restartSuccessConfirmed === true">
      <span class="troubleshoot-section__stepper__restart__reset-success__text" i18n="@@S_LIVE_MAP_DHC_RESTART_COMPLETE_CONFIRMATION_1"
        >The tracker has been restarted. Drive the vehicle to confirm it is reporting correctly.</span
      >
      <ng-container *ngIf="restartSuccessConfirmed === null">
        <span class="troubleshoot-section__stepper__restart__reset-success__text" i18n="@@S_LIVE_MAP_DHC_RESTART_COMPLETE_CONFIRMATION_2"
          >Did this fix your issue?</span
        >
        <button
          class="troubleshoot-section__stepper__restart__reset-success__button btn-uppercase"
          mat-flat-button
          color="accent"
          a7s-id="device-health-check-restart-yes-button"
          (click)="onRestartProblemFixedYes()"
        >
          <mat-icon class="mat-icon-size-xs" svgIcon="ic-thumbs-up"></mat-icon><span i18n="@@S_YES">YES</span>
        </button>
        <button
          class="troubleshoot-section__stepper__restart__reset-success__button btn-uppercase"
          mat-flat-button
          color="accent"
          a7s-id="device-health-check-restart-no-button"
          (click)="onRestartProblemFixedNo()"
        >
          <mat-icon class="mat-icon-size-xs" svgIcon="ic-thumbs-down"></mat-icon><span i18n="@@S_NO">NO</span>
        </button>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="restartSuccessConfirmed === false">
      <span
        class="troubleshoot-section__stepper__restart__reset-success__negative-confirmation__text"
        i18n="@@S_LIVE_MAP_DHC_RESTART_COMPLETE_CONFIRMATION_3"
        >If you are still having issues, read our troubleshooting guide and try again.</span
      >
      <a
        class="troubleshoot-section__stepper__restart__reset-success__negative-confirmation__link"
        [href]="vehicleTroubleshootingUrl"
        target="_blank"
      >
        <span i18n="@@S_LIVE_MAP_DHC_RESTART_TROUBLESHOOTING_GUIDE_LINK">Troubleshooting guide</span>
        <mat-icon class="mat-icon-size-xs" svgIcon="ic-link"></mat-icon>
      </a>
      <button
        class="troubleshoot-section__stepper__restart__reset-success__negative-confirmation__back-button btn-uppercase"
        mat-button
        a7s-id="device-health-check-restart-no-back-button"
        i18n="@@S_BACK"
        (click)="resetStepperToStart()"
      >
        BACK
      </button>
      <button
        class="troubleshoot-section__stepper__restart__reset-success__negative-confirmation__retry-button btn-uppercase"
        mat-flat-button
        color="accent"
        a7s-id="device-health-check-restart-no-retry-button"
        i18n="@@S_LIVE_MAP_DHC_RESTART_RETRY_BUTTON"
        (click)="onRestartClicked()"
      >
        RETRY
      </button>
    </ng-container>
  </div>
</ng-template>

<ng-template #restartStepResetFailed>
  <div
    *ngIf="restartStepState === 'ResetFailed'"
    class="troubleshoot-section__stepper__restart troubleshoot-section__stepper__restart__reset-failed"
  >
    <span class="troubleshoot-section__stepper__restart__reset-failed__text" i18n="@@S_LIVE_MAP_DHC_RESTART_FAILED_GENERIC_DESCRIPTION"
      >We could not restart the tracker. Read our troubleshooting guide and try again.</span
    >
    <a class="troubleshoot-section__stepper__restart__reset-failed__link" [href]="vehicleTroubleshootingUrl" target="_blank">
      <span i18n="@@S_LIVE_MAP_DHC_RESTART_TROUBLESHOOTING_GUIDE_LINK">Troubleshooting guide</span>
      <mat-icon class="mat-icon-size-xs" svgIcon="ic-link"></mat-icon>
    </a>
    <button
      class="troubleshoot-section__stepper__restart__reset-failed__back-button btn-uppercase"
      mat-button
      a7s-id="device-health-check-restart-restart-failed-back-button"
      i18n="@@S_BACK"
      (click)="resetStepperToStart()"
    >
      BACK
    </button>
    <button
      class="troubleshoot-section__stepper__restart__reset-failed__retry-button btn-uppercase"
      mat-flat-button
      color="accent"
      a7s-id="device-health-check-restart-restart-failed-retry-button"
      i18n="@@S_LIVE_MAP_DHC_RESTART_RETRY_BUTTON"
      (click)="onRestartClicked()"
    >
      RETRY
    </button>
  </div>
</ng-template>

<ng-template #couldNotBeRestartFromReveal>
  <div class="could-not-be-restarted-info">
    <mat-icon class="mat-icon-size-xs" svgIcon="ic-info-blue"></mat-icon>
    <span i18n="@@S_LIVE_MAP_DHC_RESTART_NOT_SUPPORTED"
      >This tracker cannot be restarted from Reveal. To restart this tracker, contact Support.</span
    >
  </div>
</ng-template>
